import { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useDrag, useDrop } from "react-dnd";
import { SceneriosCardContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";

export const SceneriosCard = (props) => {
  const ref = useRef(null);
  const { id, name, onClick, activeId, index, order, handleMoveCard } = props;

  const [{ handlerId }, drop] = useDrop({
    accept: "card",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      handleMoveCard(
        { dragIndex, order: item.order, id: item.id },
        { hoverIndex, order, id }
      );
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: () => {
      return { id, index, order };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  const isActive = name === activeId;

  drag(drop(ref));

  return (
    <SceneriosCardContainer
      ref={ref}
      style={{ opacity }}
      data-handler-id={handlerId}
      onClick={() => onClick(activeId && isActive ? {} : props)}
      className={classNames("scenario-card", {
        "active-card": isActive,
      })}
    >
      <h4 className="scenario-card-name">{name}</h4>
    </SceneriosCardContainer>
  );
};

SceneriosCard.propTypes = {
  id: PropTypes.string,
  index: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  icon: PropTypes.string,
  onClick: PropTypes.func,
  handleMoveCard: PropTypes.func,
  activeId: PropTypes.string,
  type: PropTypes.string,
  is_custom: PropTypes.bool,
  order: PropTypes.number,
};
